import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/animation/animation.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
